import React from 'react';
import { buildImagePath } from 'config/paths';

export class Avatar extends React.Component {
  constructor (props) {
    super(props);
    this.handleImageErrored = this.handleImageErrored.bind(this);
    this.powerHostBadge = this.powerHostBadge.bind(this);
  }

  handleImageErrored (event) {
    const e = event;
    e.target.src = buildImagePath('no_avatar_placeholder.svg?v=rb');
  }

  powerHostBadge () {
    const { addPowerHostBadge } = this.props;
    if (addPowerHostBadge) {
      return (
        <img alt="power host medal" className="power-host-medal" src={buildImagePath('power-host-medal.svg?v=rb')} />
      );
    }
  }

  render () {
    const { src, id, className, dataSrc } = this.props;
    const avatarLink = `https://img.peerspace.com/image/upload/c_crop,g_custom/f_auto,fl_progressive/c_scale,dpr_auto,h_100,w_100/${id}`;
    return (
      <div>
        <img
          data-src={ dataSrc ? avatarLink : null}
          src={ id ? avatarLink : src }
          alt="avatar"
          onError={ this.handleImageErrored }
          className={className ? className : 'avatar-img'}
          data-pin-nopin="true"
          style={{ maxWidth: this.props.maxWidth }}
          ref="avatar"
        />
        { this.powerHostBadge() }
      </div>);
  }
}
